"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseConsistentOption = void 0;
const dynamoDBToolboxError_js_1 = require("../errors/dynamoDBToolboxError.js");
const isBoolean_js_1 = require("../utils/validation/isBoolean.js");
const parseConsistentOption = (consistent, index) => {
    if (!(0, isBoolean_js_1.isBoolean)(consistent)) {
        throw new dynamoDBToolboxError_js_1.DynamoDBToolboxError('options.invalidConsistentOption', {
            message: `Invalid consistent option: '${String(consistent)}'. 'consistent' must be boolean.`,
            payload: { consistent }
        });
    }
    if (consistent && index !== undefined) {
        throw new dynamoDBToolboxError_js_1.DynamoDBToolboxError('options.invalidConsistentOption', {
            message: `Invalid consistent option: '${String(consistent)}'. Queries on secondary indexes cannot be consistent.`,
            payload: { consistent }
        });
    }
    return consistent;
};
exports.parseConsistentOption = parseConsistentOption;
